(() => {
  const qtyInputElement = document.querySelector('input.formQty[name="quantity"]');

  const discountLineElement = document.querySelector('.product__section--discount-line');
  const initialMsgElement = discountLineElement.querySelector('.msg-initial');
  const remainingMsgElement = discountLineElement.querySelector('.msg-remaining');
  const successMsgElement = discountLineElement.querySelector('.msg-success');
  const requiredQtyElement = discountLineElement.querySelector('.required-qty');

  if (
    !qtyInputElement ||
    !initialMsgElement ||
    !remainingMsgElement ||
    !successMsgElement ||
    !requiredQtyElement
  )
    return;

  const productID = Number(discountLineElement.dataset.productId);
  const threshold = Number(discountLineElement.dataset.threshold);
  let inCartQty = Number(discountLineElement.dataset.inCart);

  update();
  qtyInputElement.addEventListener('input', update);
  qtyInputElement.addEventListener('change', update);

  document.addEventListener('click', (e) => {
    if (e.target.closest('.quantity-control-up, .quantity-control-down')) update();
  });

  function update() {
    const qtyInputElementValue = Number(qtyInputElement.value);
    const remaining = threshold - qtyInputElementValue - inCartQty;

    requiredQtyElement.textContent = remaining;

    const isThresholdMet = remaining < 1;

    const showInitial = !isThresholdMet && qtyInputElementValue <= 1 && inCartQty === 0;

    successMsgElement.hidden = !isThresholdMet;
    initialMsgElement.hidden = !showInitial;
    remainingMsgElement.hidden = isThresholdMet || showInitial;
  }

  function getCartDrawerElement() {
    return document.querySelector('aside[data-wau-slideout="ajax-cart"]');
  }

  function onCartDrawerClosed() {
    getProductQtyInCart(productID).then((qty) => {
      console.log('qty:', qty);
      inCartQty = qty;
      update();
    });
  }
  const activeClassName = 'slideout--active';

  function watchCartDrawer(cartDrawerElement) {
    let wasOpen = cartDrawerElement.classList.contains(activeClassName);

    new MutationObserver(() => {
      const isOpen = cartDrawerElement.classList.contains(activeClassName);
      if (wasOpen && !isOpen) onCartDrawerClosed();
      wasOpen = isOpen;
    }).observe(cartDrawerElement, { attributes: true, attributeFilter: ['class'] });
  }

  const cartDrawerElement = getCartDrawerElement();

  if (cartDrawerElement) return watchCartDrawer(cartDrawerElement);

  new MutationObserver((_, observer) => {
    const cartDrawerElement = getCartDrawerElement();
    if (!cartDrawerElement) return;
    observer.disconnect();
    watchCartDrawer(cartDrawerElement);
  }).observe(document.documentElement, { childList: true, subtree: true });

  async function getProductQtyInCart(productId) {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    return cart.items
      .filter((item) => Number(item.product_id) === Number(productId)) // all variants of product
      .reduce((sum, item) => sum + item.quantity, 0);
  }
})();
